<template>
    <v-dialog
    v-model="visible"
    min-width="668px"
    max-width="668px"
    persistent
  >
    <v-card>
      <v-card-title class="dialog__header">
        <span class="dialog__title">{{ $t(`${namespace}.title`) }}</span>
        <v-btn
          class="dialog__close-btn"
          icon
          @click="close('icon')"
        >
          <v-icon dark>close</v-icon>
        </v-btn>
      </v-card-title>

      <v-card-text class="dialog__body">
        <p v-html="$t(`${namespace}.text`)" />
      </v-card-text>

      <v-divider />

      <v-card-actions class="dialog__footer">
        <v-spacer />

        <a class="accent--text mr-4" @click.prevent="close('cancel')">
          {{ $t('Common.cancel') }}
        </a>

        <v-btn
          color="primary"
          rounded
          depressed
          @click.native="close('proceed')"
        >
          {{ $t(`${namespace}.proceed`) }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'ManyEmployessDialog',
  props: {
    visible: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      namespace: 'Views.WizardPage.manyEmployessDialog'
    }
  },
  methods: {
    close (type) {
      if (type === 'icon') this.$ga.event('botao', 'clicou', 'fechar_muitoscolaboradores')
      if (type === 'cancel') this.$ga.event('botao', 'clicou', 'cancelar_muitoscolaboradores')
      if (type === 'proceed') this.$ga.event('botao', 'clicou', 'prosseguir_muitoscolaboradores')
      this.$emit('close')
    }
  }
}
</script>
